
import React from 'react'

const PdfLabel = ({
  qrCode,
  name,
  code,
  serial,
  category,
  manufacturer,
  width,
  height,
  fields,
  preview = false,
}) => {
  const qrSize = Math.min(height - 6, 30)

  return (
    <div
      className="pdf-asset-label"
      style={{
        width: preview ? '100%' : `${width}mm`,
        height: preview ? '100%' : `${height}mm`,

        boxSizing: 'border-box',
        padding: preview ? '4%' : '3mm',

        background: '#fff',

        display: 'flex',
        alignItems: 'center',
        gap: preview ? '4%' : '3mm',

        overflow: 'hidden',

        fontFamily: 'Arial, sans-serif',
        color: '#000',
      }}
    >
      <img
        src={qrCode}
        alt=""
        style={{
          width: preview ? '30%' : `${qrSize}mm`,
          height: preview ? 'auto' : `${qrSize}mm`,
          aspectRatio: '1 / 1',
          flexShrink: 0,
        }}
      />

      <div
        style={{
          minWidth: 0,
          overflow: 'hidden',
          fontSize: preview ? 'clamp(8px, 1.2vw, 11px)' : '3mm',
          lineHeight: 1.25,
        }}
      >
        {fields.name && (
          <div style={{ fontWeight: 600 }}>
            {name}
          </div>
        )}

        {fields.code && <div>{code}</div>}

        {fields.serial && (
          <div>SN: {serial}</div>
        )}

        {fields.category && (
          <div>{category}</div>
        )}

        {fields.manufacturer && (
          <div>{manufacturer}</div>
        )}
      </div>
    </div>
  )
}

export default PdfLabel
